export function renderOnePaymentOrderHeaderFor1c(data) {
    return `1CClientBankExchange\n` +
        `ВерсияФормата=1.03\n` +
        `Кодировка=Windows\n` +
        `Отправитель=Бухгалтерия предприятия, редакция 3.0\n` +
        `Получатель=\n` +
        `ДатаСоздания=\n` +
        `ВремяСоздания=\n` +
        `ДатаНачала=\n` +
        `ДатаКонца=\n` +
        `РасчСчет=${data.payer_current_account}\n` +
        `Документ=Платежное поручение`
        ;
}
export function renderOnePaymentOrderBodyFor1c(data) {
    return `СекцияДокумент=Платежное поручение\n` +
        `Номер=${data.number}\n` +
        `Дата=${new Date(data.date).toLocaleDateString('ru-RU')}\n` +
        `Сумма=${data.sum}\n` +
        `ПлательщикСчет=${data.payer_current_account}\n` +
        `Плательщик=ИНН ${data.payer_inn} ${data.payer_name}\n` +
        `ПлательщикИНН=${data.payer_inn}\n` +
        `Плательщик1=${data.payer_name}\n` +
        `ПлательщикРасчСчет=${data.payer_current_account}\n` +
        `ПлательщикБанк1=${data.payer_bank_name}\n` +
        `ПлательщикБанк2=${data.payer_bank_city}\n` +
        `ПлательщикБИК=${data.payer_bank_bic}\n` +
        `ПлательщикКорсчет=${data.payer_bank_corr_account}\n` +
        `ПолучательСчет=${data.recipient_current_account}\n` +
        `Получатель=ИНН ${data.recipient_inn} ${data.recipient_name}\n` +
        `ПолучательИНН=${data.recipient_inn}\n` +
        `Получатель1=${data.recipient_name}\n` +
        `ПолучательРасчСчет=${data.recipient_current_account}\n` +
        `ПолучательБанк1=${data.recipient_bank_name}\n` +
        `ПолучательБанк2=${data.recipient_bank_city}\n` +
        `ПолучательБИК=${data.recipient_bank_bic}\n` +
        `ПолучательКорсчет=${data.recipient_bank_corr_account}\n` +
        `ВидОплаты=01\n` +
        `Очередность=5\n` +

        `НазначениеПлатежа=${data.reason} ${data.reason_suffix} ${data.reason_suffix2}\n` +
        `НазначениеПлатежа1=${data.reason}\n` +
        `НазначениеПлатежа2=${data.reason_suffix}\n` +
        `НазначениеПлатежа3=${data.reason_suffix2}\n` +

        `Конец документа`;
}
export function renderOnePaymentOrderFooterUniversal() {
    return `Конец файла`;
}
export function renderPaymentOrderPackageHeaderForSber(firstOrderData, packageData) {
    let createAt = new Date(packageData.created_at * 1000);
    let createDate = createAt.toLocaleDateString('ru-RU');
    return `1CClientBankExchange\n` +
        `ВерсияФормата=1.03\n` +
        `Кодировка=Windows\n` +
        `Отправитель=Сбербанк Бизнес Онлайн\n` +
        `Получатель=\n` +
        `ДатаСоздания=${createDate}\n` +
        `ВремяСоздания=${createAt.toLocaleTimeString()}\n` +
        `ДатаНачала=${createDate}\n` +
        `ДатаКонца=${createDate}\n` +
        `РасчСчет=\n` +
        `СекцияРасчСчет\n` +
        `ДатаНачала=${createDate}\n` +
        `НачальныйОстаток=\n` +
        `РасчСчет=${firstOrderData.payer_current_account}\n` +
        `КонецРасчСчет`
        ;
}
export function renderOnePaymentOrderHeaderForSber(orderData) {
    let createAt = new Date(orderData.created_at * 1000);
    let createDate = createAt.toLocaleDateString('ru-RU');
    return `1CClientBankExchange\n` +
        `ВерсияФормата=1.03\n` +
        `Кодировка=Windows\n` +
        `Отправитель=Сбербанк Бизнес Онлайн\n` +
        `Получатель=\n` +
        `ДатаСоздания=${createDate}\n` +
        `ВремяСоздания=${createAt.toLocaleTimeString()}\n` +
        `ДатаНачала=${createDate}\n` +
        `ДатаКонца=${createDate}\n` +
        `РасчСчет=\n` +
        `СекцияРасчСчет\n` +
        `ДатаНачала=${createDate}\n` +
        `НачальныйОстаток=\n` +
        `РасчСчет=${orderData.payer_current_account}\n` +
        `КонецРасчСчет`
        ;
}
export function renderOnePaymentOrderBodyForSber(data) {
    return `СекцияДокумент=Платежное поручение\n` +
        `Номер=${data.number}\n` +
        `Дата=${new Date(data.date).toLocaleDateString('ru-RU')}\n` +
        `Сумма=${data.sum}\n` +
        `ПлательщикСчет=${data.payer_current_account}\n` +
        `Плательщик=${data.payer_name}\n` +
        `ПлательщикИНН=${data.payer_inn}\n` +
        `ПлательщикКПП=\n` +
        `ПлательщикРасчСчет=${data.payer_current_account}\n` +
        `ПлательщикБанк1=${data.payer_bank_name}\n` +
        `ПлательщикБИК=${data.payer_bank_bic}\n` +
        `ПлательщикКорсчет=${data.payer_bank_corr_account}\n` +
        `ПолучательСчет=${data.recipient_current_account}\n` +
        `Получатель=${data.recipient_name}\n` +
        `ПолучательИНН=${data.recipient_inn}\n` +
        `ПолучательКПП=${data.recipient_kpp}\n` +
        `ПолучательРасчСчет=${data.recipient_current_account}\n` +
        `ПолучательБанк1=${data.recipient_bank_name}\n` +
        `ПолучательБИК=${data.recipient_bank_bic}\n` +
        `ПолучательКорсчет=${data.recipient_bank_corr_account}\n` +
        `ВидПлатежа=Электронно\n` +
        `ВидОплаты=01\n` +
        `Код=\n` +
        `СтатусСоставителя=\n` +
        `ПоказательКБК=\n` +
        `ОКАТО=\n` +
        `ПоказательОснования=\n` +
        `КодВидаВалютнойОперации=\n` +
        `КодНазПлатежа=\n` +
        `ПоказательПериода=\n` +
        `ПоказательНомера=\n` +
        `ПоказательДаты=\n` +
        `ПоказательТипа=\n` +
        `Очередность=5\n` +
        `НазначениеПлатежа=${data.reason} ${data.reason_suffix} ${data.reason_suffix2}\n` +

        `КонецДокумента`;
}
